import React, {
  useContext, useState, useEffect, createRef
} from "react";
import ProductContext from "services/product-context";
import { addCartItems, fetchCart } from "data/cart";
import GlobalContext from "services/global-context";
import gaEvent from "helpers/ga-event";
import { triggerProductAddedEventMable } from "helpers/analytics";
import {
  singleProduct, productTitle, benefits, cartBtn, borderLine, desktopView, mobileView,
  productTitlePrice, paymentIcons, addToCart, blockedVariantStyle, disabledBtn,
  mobileCookingHub, titlePriceBox, freeShippingText, priceBox, titleAndReviews, variantSnippet,
  returnText, returnInfo
} from "./style.mod.scss";
import CookingHub from "components/cooking-hub";
import PDPCampaign from "components/pdp-campaign";
import CrossSellProducts from "../cross-sell-pdp";
import locale from "locales";
import getImagePath from "helpers/get-image-path";
import Scalapay from "components/scalapay";
import Countdown from "components/countdown";
import ShortInfo from "components/short-info";
import RichText from "components/rich-text";
import EcoPackageUpsell from "components/eco-package-upsell";
import ReCoatingService from "components/re-coating-service";
import BackInStock from "components/back-in-stock-snippet";
import BlockCheckoutModal from "components/block-checkout-modal";
import CreateSet from "components/create-set";
import ProductPrice from "./pdp-prices";
import ProductShippingDetails from "./product-shipping-details";
import ProductVariants from "./pdp-variants";
import PDPReviews from "components/pdp-reviews";
import PDPAccordions from "components/pdp-accordions";
import { trackAddedToCartKlaviyo } from "helpers/analytics";
import Image from "components/image";
import Box from "assets/svgs/retoure.svg";

const PdpVariations = (props) => {
  const {
    currentVariant,
    currentVariant: { ecoPackage, crossSellProducts, createSet, reCoatingService, store: { compareAtPrice, price } },
    onAddToCart,
    settings,
    product,
    enhancedPDP,
    enhancedPDPContent
  } = props;
  const { title, content } = useContext(ProductContext);
  const pdpTemplate = content?.pdpTemplate;
  const [crossSellVariants, setCrossSellVariants] = useState({});
  const [createSetVariants, setCreateSetVariants] = useState({});
  const [coatingServiceAdded, setCoatingServiceAdded] = useState(false);
  const paymentImage = settings?.PDPSettings?.paymentImage;
  const [open, setOpen] = useState(false);
  const blockVariants = settings?.Cart?.blockVariants;
  const variantID = blockVariants?.variants?.map(variant => variant?.id);
  const productContext = useContext(ProductContext);
  const variantPackage = currentVariant?.replacePackage?.id && !currentVariant?.store?.inStock ? currentVariant?.replacePackage : currentVariant;

  let checkBlockedVariant = false;
  if (variantID?.includes(currentVariant?.id)) {
    checkBlockedVariant = true;
  }

  const showModal = () => {
    setOpen(true);
  };

  const hideModal = () => {
    setOpen(false);
  };

  const [totalPrice, setTotalPrice] = useState(parseFloat(currentVariant.store.price));
  const [totalCompareAtPrice, setTotalCompareAtPrice] = useState(parseFloat(currentVariant.store.compareAtPrice));
  const [ctaDisabled, setDisabled] = useState(false);
  const [choseEcoVariant, setChoseEcoVariant] = useState(false);
  const { toggleCart, cartOpened } = useContext(GlobalContext);

  let isAvailableForSale = variantPackage?.store?.inStock;

  useEffect(() => {
    setDisabled(!isAvailableForSale);
  }, [isAvailableForSale]);


  const handleAddToCart = async () => {
    triggerProductAddedEventMable(productContext);
    setDisabled(true);

    let productsToAdd = [];

    if (choseEcoVariant) {
      productsToAdd.push(ecoPackage?.variant);
      productsToAdd = productsToAdd.concat(getSelectedVariants(crossSellVariants));
      productsToAdd = productsToAdd.concat(getSelectedVariants(createSetVariants));
    } else {
      const selectedSetVariants = getSelectedVariants(createSetVariants);
      if (selectedSetVariants.length > 0) {
        productsToAdd = productsToAdd.concat(selectedSetVariants);
        if (Object.keys(crossSellVariants).length > 0) {
          productsToAdd = productsToAdd.concat(getSelectedVariants(crossSellVariants));
        }
      } else {
        productsToAdd = productsToAdd.concat(getSelectedVariants(crossSellVariants));
        await onAddToCart(variantPackage, productsToAdd);
      }

    }

    if (coatingServiceAdded) {
      productsToAdd.push(reCoatingService.variant);
    }

    if (productsToAdd?.length > 0) {
      await addCartItems(productsToAdd.map(variant => variant?.id));
    }

    gaEvent("PDP", "Click", "Added to cart");
    if (!cartOpened) {
      toggleCart();
    }
    const cart = await fetchCart();
    trackAddedToCartKlaviyo(cart, currentVariant);

    setDisabled(false);
  };

  const getSelectedVariants = (variantsObj) => Object.keys(variantsObj).filter(id => variantsObj[id]).map(id => variantsObj[id]);

  const layoutRef = createRef();

  const productSettings = settings?.PDPSettings;

  let overwriteGiftpackages = productSettings?.overwriteCrossSell;
  if (crossSellProducts?.enableCrossSell) overwriteGiftpackages = false;
  
  const mergedReviewVariants = product.clusterReviews;

  const shouldExcludeBenefit = "pfanne-32x5_8cm-beschichtet";
  console.log(shouldExcludeBenefit);

  return (
    <div className={singleProduct} ref={layoutRef}>
      <div className={desktopView}>
        <h1 className={productTitle} dangerouslySetInnerHTML={{ __html: title }} />
        {!enhancedPDP &&
          <PDPReviews variants={mergedReviewVariants} />}
        {content?.benefits && (
          <div className={benefits}>
            <RichText
              blocks={content?.benefits.filter((_, index) => {
                return !(currentVariant?.store?.sku === shouldExcludeBenefit && index === 3);
              })}
            />
          </div>
        )}
        <PDPCampaign content={content} pdpSettings={settings?.PDPSettings} />
        <ProductPrice
          totalPrice={totalPrice}
          discountBadge={settings?.PDPSettings?.showYouSave}
          currentVariant={currentVariant} />
        {enhancedPDP &&
          <PDPReviews variants={mergedReviewVariants} />}

      </div>
      <div className={mobileView}>
        {enhancedPDP ? <>
          <div className={productTitlePrice}>
            <div className={titlePriceBox}>
              <div className={titleAndReviews}>
                <h1 className={productTitle} dangerouslySetInnerHTML={{ __html: title }} />
              </div>
              <div className={priceBox}>
                <ProductPrice
                  totalPrice={totalPrice}
                  discountBadge={settings?.PDPSettings?.showYouSave}
                  currentVariant={currentVariant} />
                <span className={freeShippingText}>{locale?.products?.shippingFree}</span>
              </div>
            </div>
            {!enhancedPDP && content?.benefits && <div id="benefits-mobile" className={benefits}>
              <RichText blocks={content?.benefits} />
            </div>}
          </div>
          <PDPReviews variants={mergedReviewVariants} />
        </> : <>
          <h1 className={productTitle} dangerouslySetInnerHTML={{ __html: title }} />
          <PDPReviews variants={mergedReviewVariants} />
          {content?.benefits && <div className={benefits}>
            <RichText blocks={content?.benefits} />
          </div>}
          <ProductPrice
            totalPrice={totalPrice}
            discountBadge={settings?.PDPSettings?.showYouSave}
            currentVariant={currentVariant} />

        </>}
      </div>
      <ProductVariants product={product} currentVariant={currentVariant} props={props} />

      {createSet?.variants &&
        <CreateSet
          variants={createSet?.variants}
          createSetVariants={createSetVariants}
          setCreateSetVariants={setCreateSetVariants}
          totalPrice={totalPrice}
          setTotalPrice={setTotalPrice}
          totalCompareAtPrice={totalCompareAtPrice > 0 ? totalCompareAtPrice : totalPrice}
          setTotalCompareAtPrice={setTotalCompareAtPrice}
          template={pdpTemplate} />}

      <div className={variantSnippet}>
        <Image image={currentVariant?.snippet} alt={currentVariant?.snippet?.alt} />
      </div>
      {!isAvailableForSale &&
        <BackInStock variant={currentVariant} />}

      {checkBlockedVariant ? <button id="addToCart" className={`${cartBtn} ${blockedVariantStyle}`} onClick={showModal} disabled={ctaDisabled}>{locale.products.notifyMe}</button> :
        <>
          {productSettings.returnText && <div className={returnInfo}>
            <Box />
            <p className={returnText}>{productSettings.returnText}</p>
          </div>}
          {totalPrice <= 0 ? <button className={`${cartBtn} ${disabledBtn}`} disabled={() => { setDisabled(true); }}><p className={addToCart}>{locale.products.addToCart}</p></button> : <button id="addToCart" className={cartBtn} onClick={handleAddToCart} disabled={ctaDisabled}>{isAvailableForSale ? <p className={addToCart}>{locale.products.addToCart}</p> : locale.products.soldOut}</button>}
        </>
      }
      {!enhancedPDP &&
        <div>
          <Scalapay total={price} scalapaySetting={settings?.PDPSettings?.showScalapay} />
          {paymentImage &&
            <img className={paymentIcons} src={getImagePath(paymentImage)} alt={paymentImage?.alt} />}
        </div>}

      {(ecoPackage?.variant && currentVariant?.enableCrossSell && overwriteGiftpackages) && (
        <EcoPackageUpsell
          ecoPackage={ecoPackage}
          setChoseEcoVariant={setChoseEcoVariant}
          choseEcoVariant={choseEcoVariant}
          setTotalPrice={setTotalPrice}
          setTotalCompareAtPrice={setTotalCompareAtPrice}
          variantPrice={parseFloat(price)}
          variantPriceAtCompare={compareAtPrice > 0 ? parseFloat(compareAtPrice) : parseFloat(price)}
          template={pdpTemplate}
          enhancedPDP={enhancedPDP}
          enhancedPDPContent={enhancedPDPContent}
          overwriteSettingsCrossSell={currentVariant?.enableCrossSell}
          crossSellStyle={ecoPackage?.crossSellStyle}
          totalPrice={totalPrice}
        />
      )}
      {(!ecoPackage?.variant || productSettings?.overwriteCrossSell) && (
        <CrossSellProducts
          title={crossSellProducts.title}
          variants={crossSellProducts?.variants}
          crossSellVariants={crossSellVariants}
          setCrossSellVariants={setCrossSellVariants}
          totalPrice={totalPrice}
          setTotalPrice={setTotalPrice}
          totalCompareAtPrice={totalCompareAtPrice > 0 ? totalCompareAtPrice : totalPrice}
          setTotalCompareAtPrice={setTotalCompareAtPrice}
          template={pdpTemplate}
          enhancedPDP={enhancedPDP}
          enhancedPDPContent={enhancedPDPContent}
          ecoPackage={ecoPackage}
          pdpSettings={productSettings}
          overwriteSettingsCrossSell={currentVariant?.enableCrossSell}
          crossSellStyle={crossSellProducts?.crossSellStyle}
          uniqueKey={crossSellProducts?._rev}
        />
      )}

      {reCoatingService?.variant?.id && !ecoPackage?.variant && (
        <ReCoatingService
          service={reCoatingService}
          setCoatingServiceAdded={setCoatingServiceAdded}
          totalPrice={totalPrice}
          setTotalPrice={setTotalPrice}
          totalCompareAtPrice={totalCompareAtPrice > 0 ? totalCompareAtPrice : totalPrice}
          setTotalCompareAtPrice={setTotalCompareAtPrice}
        />
      )}

      <div className={mobileView}>
        <PDPCampaign pdpSettings={settings?.PDPSettings} />
      </div>


      <BlockCheckoutModal data={blockVariants}
        open={open}
        hideModal={hideModal}
      />

      <ProductShippingDetails
        miniIcons={currentVariant?.productInfo?.miniIcons}
        pdpTemplate={content?.pdpTemplate}
        enhancedPDP={content?.enhancedPDP}
        content={content}
        inStock={isAvailableForSale || undefined}
        restockDate={currentVariant?.store?.restockDate}
      />

      <div className={borderLine}></div>
      <Countdown data={settings?.Countdown} />
      {!enhancedPDP &&
        <ShortInfo content={content} />}

      <div className={mobileView}>
        {content?.showCookingHub &&
          <div className={mobileCookingHub}>
            <CookingHub data={productSettings} />
          </div>}
        {currentVariant?.variantAccordions?.map((item, i) => (<PDPAccordions item={item} key={i} />))}
      </div>
    </div>
  );
};

export default PdpVariations;